import styled from 'styled-components';
import theme from '../../theme';

export default styled.div`
  background: ${theme.colors.white};
  border-top: 1px solid ${theme.colors.light};
  border-bottom: 1px solid ${theme.colors.light};
  padding: 7px 45px;
  @media (max-width: ${theme.breakpoints.desktopLarge}) {
    padding: 5px 20px;
  }
  margin-bottom: 10px;
  color: ${theme.colors.mediumlight};
`;
